product.divisionCode = document.getElementById("division-code");
product.productGroupCode = document.getElementById("group-code");
product.offer = document.getElementById("offer");

const svg15off = `
<svg class="discount-label" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 669 270.69">
  <defs>
    <style>
      .cls-1 {fill: #fff}
      .cls-1, .cls-2 {stroke-width: 0px}
      .cls-2 {fill: #e20613}
    </style>
  </defs>
  <g>
    <g>
      <rect class="cls-2" width="669" height="270.69"/>
      <g>
        <path class="cls-1" d="m175.62,134.22v26.99h-49.47v-26.99h49.47Z"/>
        <path class="cls-1" d="m216.44,102.91h-20.07l10.9-31.14h44.46v124.2h-35.29v-93.07Z"/>
        <path class="cls-1" d="m273.18,171.93l29.58-15.05c1.27,3.46,3.03,6.52,5.28,9.17,2.25,2.65,5.33,3.98,9.25,3.98,3.69,0,6.6-1.27,8.74-3.81,2.13-2.54,3.2-6.34,3.2-11.42s-1.04-9.08-3.11-11.68-4.9-3.89-8.48-3.89c-2.31,0-4.41.55-6.31,1.64-1.9,1.1-3.55,2.45-4.93,4.07l-29.93-6.05,13.32-67.12h70.75v28.72h-47.74l-3.29,14.88c5.07-2.19,10.55-3.29,16.43-3.29,5.54,0,10.73.95,15.57,2.85,4.84,1.9,9.08,4.64,12.71,8.22,3.63,3.58,6.51,7.99,8.65,13.23,2.13,5.25,3.2,11.22,3.2,17.9,0,7.04-1.27,13.32-3.8,18.86-2.54,5.54-6,10.21-10.38,14.01-4.38,3.81-9.51,6.72-15.4,8.74-5.88,2.02-12.11,3.03-18.68,3.03-5.88,0-11.16-.72-15.83-2.16-4.67-1.44-8.85-3.4-12.54-5.88-3.69-2.48-6.86-5.36-9.51-8.65-2.65-3.29-4.9-6.72-6.75-10.29Z"/>
        <path class="cls-1" d="m410.52,68.66c4.5,0,8.33.26,11.5.78,3.17.52,6.23,1.07,9.17,1.64,2.94.58,6.14,1.12,9.6,1.64,3.46.52,7.67.78,12.63.78,3.69,0,6.83-.14,9.43-.43,2.59-.29,5.02-.72,7.27-1.3,2.25-.58,4.55-1.32,6.92-2.25,2.36-.92,5.1-2.02,8.22-3.29h29.41l-84.24,138.22h-29.41l66.6-110.88c-2.08.46-4.24.84-6.49,1.12-2.25.29-4.53.43-6.83.43-1.73,0-3.37-.06-4.93-.17-1.56-.11-3.03-.29-4.41-.52,1.04,3.11,1.56,6.52,1.56,10.21,0,4.96-.95,9.63-2.85,14.01-1.9,4.38-4.5,8.19-7.78,11.42-3.29,3.23-7.09,5.77-11.42,7.61-4.32,1.85-8.97,2.77-13.93,2.77s-9.63-.92-14.01-2.77c-4.38-1.84-8.19-4.38-11.42-7.61-3.23-3.23-5.77-7.03-7.61-11.42-1.85-4.38-2.77-9.05-2.77-14.01s.92-9.63,2.77-14.01c1.84-4.38,4.38-8.19,7.61-11.42,3.23-3.23,7.03-5.79,11.42-7.7,4.38-1.9,9.05-2.85,14.01-2.85Zm0,47.74c3.34,0,6.17-1.12,8.48-3.37,2.31-2.25,3.46-5.04,3.46-8.39s-1.15-6.17-3.46-8.48c-2.31-2.31-5.13-3.46-8.48-3.46s-6.14,1.15-8.39,3.46c-2.25,2.31-3.37,5.13-3.37,8.48s1.13,6.14,3.37,8.39c2.25,2.25,5.04,3.37,8.39,3.37Zm96.35,10.72c4.96,0,9.6.95,13.93,2.85s8.13,4.47,11.42,7.7c3.29,3.23,5.88,7.04,7.78,11.42,1.9,4.38,2.85,9.05,2.85,14.01s-.95,9.63-2.85,14.01c-1.9,4.38-4.5,8.19-7.78,11.42-3.29,3.23-7.09,5.77-11.42,7.61-4.32,1.84-8.97,2.77-13.93,2.77s-9.63-.92-14.01-2.77c-4.38-1.84-8.19-4.38-11.42-7.61-3.23-3.23-5.77-7.03-7.61-11.42-1.85-4.38-2.77-9.05-2.77-14.01s.92-9.63,2.77-14.01c1.84-4.38,4.38-8.19,7.61-11.42,3.23-3.23,7.03-5.79,11.42-7.7,4.38-1.9,9.05-2.85,14.01-2.85Zm-11.76,35.98c0,3.35,1.12,6.14,3.37,8.39,2.25,2.25,5.04,3.37,8.39,3.37s6.17-1.12,8.48-3.37c2.31-2.25,3.46-5.04,3.46-8.39s-1.15-6.17-3.46-8.48c-2.31-2.31-5.13-3.46-8.48-3.46s-6.14,1.15-8.39,3.46c-2.25,2.31-3.37,5.13-3.37,8.48Z"/>
      </g>
    </g>
  </g>
</svg>`;

const recommendations = {
  store: shasaStores[0],
  container: document.getElementById("ia-recommendations"),
  render(data) {
    // console.log(data);
    for (const handle of data.items) {
      fetch(`https://shasa.com/products/${handle}.js`)
        .then((res) => res.json())
        .then((product) => {
          // console.log(product);
          if (product.available) {
            let options = "";
            for (const variant of product.variants) {
              if (variant.available) {
                options += `<option value="${variant.id}">${variant.title}</option>`;
              }
            }
            const form = document.createElement("form");
            const select = document.createElement("select");
            const submit = document.createElement("input");
            form.method = "post";
            form.action = "/cart/add";
            select.name = "id";
            select.innerHTML = options;
            submit.type = "submit";
            submit.className = "button button--primary button--full-width";
            submit.value = "Agregar a mi bolsa";
            form.appendChild(select);
            form.appendChild(submit);
            const link = document.createElement("a");
            link.href = `/products/${handle}`;
            if (product.tags.includes("BUENFIN")) {
              link.innerHTML = svg15off;
            } else if (product.tags.includes("descuento")) {
              link.innerHTML = `
                <div class="discount-label sale">
                  <p>
                    -${Math.ceil(
                      100 - (product.price / product.compare_at_price) * 100
                    )}%
                  </p>
                </div>
              `;
            }
            link.innerHTML += `
              <img src="${product.featured_image}&width=400" alt="${product.title}"/>
              <h3 class="card__title h5">${product.title}</h3>
              `;
            if (product.compare_at_price) {
              link.innerHTML += `<p>$${product.price / 100}.00 &nbsp; <s>$${
                product.compare_at_price / 100
              }.00</s></p>`;
            } else {
              link.innerHTML += `<p>$${product.price / 100}.00</p>`;
            }
            const card = document.createElement("div");
            card.className = "recommendation-card";
            card.appendChild(link);
            card.appendChild(form);
            recommendations.container.appendChild(card);
          }
        });
    }
  },
  init: () => {
    const group = product.productGroupCode.value.toLowerCase().replace(" ", "");
    const cluster = recommendations.store.cluster;
    const offer = product.offer.value;
    let name = group + cluster + offer;
    fetch(`https://shasa.com/cdn/shop/t/79/assets/sr${cluster}.json`)
      .then((response) => response.json())
      .then((res) => {
        // console.log({name});
        if (res[name]) {
          // console.log(res[name]);
          recommendations.render(res[name]);
        } else {
          name = product.divisionCode.value.startsWith("M")
            ? "top_ventasman"
            : "top_ventaswoman";
          fetch("https://shasa.com/cdn/shop/t/79/assets/srtop_ventas.json")
            .then((response) => response.json())
            .then((res) => {
              recommendations.render(res[name]);
            });
        }
      });
  },
};
recommendations.init();
